document.addEventListener("DOMContentLoaded", function () {

    function formatCurrency(num) {
        // 转换为字符串，并添加两位小数
        var str = num.toFixed(2);

        // 使用正则表达式添加千位分隔符
        str = str.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

        return str;
    }

    customElements.define('laserpacker-custom-product-details', class extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({mode: 'open'});
            this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
            this.shadowRoot.innerHTML = `
                    <div class="container">
                        <div class="product-details">
                            <div class="product-images">
                                <img id="product-image" src="https://via.placeholder.com/600x600" alt="Product Image">
                            </div>
                            <div class="product-info">
                                <p id="product-title" class="product-title">Loading...</p>
<!--                                <p id="product-description" class="product-description">Loading...</p>-->
                                <p style="margin-bottom: 20px;">
                                    <span id="product-price" class="product-price"></span>
                                    <span id="product-original-price" class="product-original-price"></span>
                                </p>
                                <div class="select-box">
                                    <label for="product-package" class="select-box-label">Package:</label>
                                    <select id="product-package" class="select-box-select">
                                        <option value="size1">Loading...</option>
                                    </select>
                                </div>
                                <div class="select-box">
                                    <label for="product-adapter" class="select-box-label">Adapter:</label>
                                    <select id="product-adapter" class="select-box-select">
                                        <option value="color1">Loading...</option>
                                    </select>
                                </div>
<!--                                <button id="add-to-cart-btn" class="add-to-cart-btn">Add to Cart</button>-->
                                <div style="display: flex;justify-content: space-between;">
                                <product-form style="display: block">
                                <form method="post" action="/cart/add" id="product-form-template--22222511145256__main-sticky" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                <input type="hidden" name="form_type" value="product">
                                <input type="hidden" name="utf8" value="✓">
                                <input type="hidden" id="Option-template--v22222511145256__main-input-id-sticky" name="id" value="">
                                <input type="hidden" name="quantity" min="1" value="1">
                                <button type="submit" name="add" id="add-to-cart-btn" class="add-to-cart-btn" aria-labelledby="card-submit-button-template--22222511145256__main" aria-haspopup="dialog">
                                   <span class="addSpan" id="addToCartSpan">Add to cart</span>
                                   <div class="loading-overlay__spinner hidden">
                                   <svg version="1.1" id="L5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
  <circle fill="currentColor" stroke="none" cx="10" cy="70" r="10">
    <animateTransform attributeName="transform" dur="1s" type="translate" values="0 15 ; 0 -15; 0 15" repeatCount="indefinite" begin="0.1"></animateTransform>
  </circle>
  <circle fill="currentColor" stroke="none" cx="50" cy="70" r="10">
    <animateTransform attributeName="transform" dur="1s" type="translate" values="0 10 ; 0 -10; 0 10" repeatCount="indefinite" begin="0.2"></animateTransform>
  </circle>
  <circle fill="currentColor" stroke="none" cx="90" cy="70" r="10">
    <animateTransform attributeName="transform" dur="1s" type="translate" values="0 5 ; 0 -5; 0 5" repeatCount="indefinite" begin="0.3"></animateTransform>
  </circle>
</svg>
                                   </div>
                                 </button>
                                <input type="hidden" id="product-id-input" name="product-id" value="">
                                <input type="hidden" name="section-id" value="template--v22222511145256__main">
                                </form>
                                </product-form>
                                <button id="more-btn" class="more-btn">View More</button>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>
                `;
        }

        connectedCallback() {
            const productHandle = this.getAttribute('product-handle');
            const productTitleElement = this.shadowRoot.getElementById('product-title');
            // const productDescriptionElement = this.shadowRoot.getElementById('product-description');
            const productPriceElement = this.shadowRoot.getElementById('product-price');
            const productOriginalPriceElement
                = this.shadowRoot.getElementById('product-original-price');
            const productImageElement = this.shadowRoot.getElementById('product-image');
            const productPackageSelect = this.shadowRoot.getElementById('product-package');
            const productAdapterSelect = this.shadowRoot.getElementById('product-adapter');
            const addToCartButton = this.shadowRoot.getElementById('add-to-cart-btn');
            const moreBtnButton = this.shadowRoot.getElementById('more-btn');
            const vIdInput = this.shadowRoot.getElementById('Option-template--v22222511145256__main-input-id-sticky');
            const productIdInput = this.shadowRoot.getElementById('product-id-input');
            const addToCartSpan = this.shadowRoot.getElementById('addToCartSpan');


            fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
                .then(response => response.json())
                .then(product => {
                    console.log(product);
                    const productInfo = {
                        title: product.title,
                        // description: product.description,
                        price: `$${formatCurrency(product.price / 100)} USD`,
                        originalPrice: `$${formatCurrency(product.compare_at_price / 100)}`,
                        imageSrc: product.featured_image,
                        packages: product.options[0].values,
                        adapters: product.options[1].values
                    };

                    // 更新商品详情块的内容
                    productTitleElement.textContent = productInfo.title;
                    // productDescriptionElement.textContent = productInfo.description;
                    productPriceElement.textContent = productInfo.price;
                    productOriginalPriceElement.textContent = productInfo.originalPrice;
                    productImageElement.src = productInfo.imageSrc;

                    // 更新商品规格选择框
                    productPackageSelect.innerHTML = '';
                    productInfo.packages.forEach(packageOption => {
                        const option = document.createElement('option');
                        option.value = packageOption;
                        option.textContent = packageOption;
                        productPackageSelect.appendChild(option);
                    });

                    productAdapterSelect.innerHTML = '';
                    productInfo.adapters.forEach(adapterOption => {
                        const option = document.createElement('option');
                        option.value = adapterOption;
                        option.textContent = adapterOption;
                        productAdapterSelect.appendChild(option);
                    });

                    handleSelectChange();

                    function handleSelectChange() {
                        const variants = product.variants;
                        const itemVariant = variants.find(variant => {
                            return variant.option1 === productPackageSelect.value && variant.option2 === productAdapterSelect.value;
                        })
                        console.log(itemVariant);
                        if (itemVariant) {
                            productPriceElement.textContent = `$${formatCurrency(itemVariant.price / 100)} USD`;
                            productOriginalPriceElement.textContent = `$${formatCurrency(itemVariant.compare_at_price / 100)}`;
                            productImageElement.src = itemVariant.featured_image.src;
                            vIdInput.value=itemVariant.id;
                            productIdInput.value=product.id;
                            if(!itemVariant.available) {
                                addToCartSpan.textContent = 'Sold Out';
                                addToCartButton.disabled = true;
                                addToCartButton.style.cursor = 'not-allowed';
                                addToCartButton.style.opacity = '0.5';
                            }else {
                                addToCartSpan.textContent = 'Add to cart';
                                addToCartButton.disabled = false;
                                addToCartButton.style.cursor = 'pointer';
                                addToCartButton.style.opacity = '1';
                            }
                        }
                    }

                    productPackageSelect.addEventListener('change', handleSelectChange);
                    productAdapterSelect.addEventListener('change', handleSelectChange);


                    // addToCartButton.addEventListener('click', () => {
                    //     console.log('Product added to cart!');
                    //
                    //     const variants = product.variants;
                    //     const itemVariant = variants.find(variant => {
                    //         return variant.option1 === productPackageSelect.value && variant.option2 === productAdapterSelect.value;
                    //     })
                    //     console.log(itemVariant);
                    //     if (itemVariant) {
                    //         if (!itemVariant.available) {
                    //             addToCartButton.textContent = 'Sold Out';
                    //             setTimeout(() => {
                    //                 addToCartButton.textContent = 'Add to Cart';
                    //             }, 2000);
                    //             return false;
                    //         }
                    //         addToCartButton.textContent = 'Adding...';
                    //
                    //         let formData = {
                    //             'items': [{
                    //                 'id': itemVariant.id,
                    //                 'quantity': 1
                    //             }]
                    //         };
                    //         fetch(window.Shopify.routes.root + 'cart/add.js', {
                    //             method: 'POST',
                    //             headers: {
                    //                 'Content-Type': 'application/json'
                    //             },
                    //             body: JSON.stringify(formData)
                    //         })
                    //             .then(response => {
                    //                 //return response.json();
                    //                 // window.location.href='/cart';
                    //                 addToCartButton.textContent = 'Thank you!';
                    //                 this.cart.open();
                    //                 setTimeout(() => {
                    //                     addToCartButton.textContent = 'Add to Cart';
                    //                 }, 2000);
                    //             })
                    //             .catch((error) => {
                    //                 console.error('Error:', error);
                    //             });
                    //     }
                    // });
                    moreBtnButton.addEventListener('click', () => {
                        console.log('View More!');
                        window.location.href = `/products/${productHandle}`;
                    })
                });
        }
    });
});
document.addEventListener("DOMContentLoaded", function () {
    // 获取所有具有 laserpacker-custom-product-details 类的元素
    const customProductDetailsElements = document.querySelectorAll('.laserpacker-custom-product-details');

    // 遍历每个元素并处理
    customProductDetailsElements.forEach(element => {
        if (element.textContent) {
            element.textContent = "";
            // 获取元素的 data-handle 属性值
            const productHandle = element.getAttribute('data-handle');

            // 创建 <laserpacker-custom-product-details> 子元素并设置 product-handle 属性
            const customProductDetailsElement = document.createElement('laserpacker-custom-product-details');
            customProductDetailsElement.setAttribute('product-handle', productHandle);

            // 将创建的子元素添加到当前元素中
            element.appendChild(customProductDetailsElement);
        }
    });
});
